import React, { useState, useEffect, useRef } from 'react';
import "../AdminPanel/AdminPanel.css"
;



const AdminPanel = ({ setAdminSubTab }) => {

    return (
      <>
        <div className='Datasetcomponent'>
          <div
            className='DataTitle'
            onClick={() => setAdminSubTab('system')}
          >
            사용자 관리
          </div>
        </div>
        <div className='Datasetcomponent'>
          <div
            className='DataTitle'
            onClick={() => setAdminSubTab('log')}
          >
            로그 기록
          </div>
        </div>
        {/* <div className='Datasetcomponent'>
          <div className='DataTitle'>
            환경 설정
          </div>
        </div>
        <div className='Datasetcomponent'>
          <div className='DataTitle'>
            통계
          </div>
        </div> */}
      </>
    );
  };
  

export default AdminPanel;


